import React, { PropsWithChildren, useContext } from 'react';

import { DndProvider, DndContext, DndProviderProps } from 'react-dnd';

type Props<BackendContext, BackendOptions> = PropsWithChildren<
  DndProviderProps<BackendContext, BackendOptions>
>;

export function SafeDndProvider<BackendContext = unknown, BackendOptions = unknown>({
  children,
  ...props
}: Props<BackendContext, BackendOptions>) {
  // Check if we're already inside a DndProvider by accessing the context
  const contextValue = useContext(DndContext);
  const existingManager = contextValue?.dragDropManager;

  // If we already have a drag-drop manager, don't create a new provider
  // This prevents multiple HTML5 backends from being initialized
  if (existingManager) {
    return <>{children}</>;
  }

  // Only create a new DndProvider if one doesn't already exist
  return <DndProvider {...props}>{children}</DndProvider>;
}
